import React from 'react';
import {Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './TopButtonsStyles';

export const TopSimpleButton = (props) => {
    return (
        <Button
            onClick={props.onClick}
            bsSize={props.size}
            bsStyle={props.style}
            disabled={props.disabled}
            style={props.additionalStyle}
        >
            {props.text}
        </Button>
    );
};

TopSimpleButton.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string,
    size: PropTypes.string,
    style: PropTypes.string,
    disabled: PropTypes.bool,
    additionalStyle: PropTypes.string,
};

TopSimpleButton.defaultProps = {
    text: 'Button',
    style: 'primary',
    disabled:false,
};

export const TopButtonCancel = (props) => {
    return (
        <Button
            onClick={props.onClick}
            bsSize={props.buttonSize}
            bsStyle='default'
            style={styles.buttonCancelStyle}
            {...props}
        >
            <i className='fa fa-lg fa-close' style={styles.faIconStyle}></i>{props.text}
        </Button>
    );
};

TopButtonCancel.propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonSize: PropTypes.string,
    text: PropTypes.string
};

TopButtonCancel.defaultProps = {
    text: 'Anuluj'
};

export const TopButtonSave = (props) => {
    return (
        <Button onClick={props.onClick}
                style={styles.buttonStyle}
                bsStyle='primary'
                bsSize={props.buttonSize}
                disabled={props.disabled}
        ><i className='fa fa-lg fa-save' style={styles.faIconStyle}></i> {props.text}</Button>
    );
};

TopButtonSave.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    buttonSize: PropTypes.string,
    disabled: PropTypes.bool,
};

TopButtonSave.defaultProps = {
    text: 'Zapisz',
    buttonSize: '',
    disabled:false,
};


export const TopButtonAdd = (props) => {
    return (
        <Button onClick={props.onClick}
                style={styles.buttonStyle}
                bsStyle='success'
                bsSize={props.buttonSize}
                disabled={props.disabled}
        ><i className='fa fa-lg fa-plus' style={styles.faIconStyle}></i> {props.text}</Button>
    );
};

TopButtonAdd.propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonSize: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool
};

TopButtonAdd.defaultProps = {
    text: 'Dodaj',
    disabled: false
};


export const TopButtonAction = (props) => {
    return (
        <Button onClick={props.onClick}
                style={{fontWeight:'bold', ...props.elementStyle}}
                bsStyle={props.btnColor}
                bsSize={props.btnSize}
                disabled={props.btnDisabled}
                id={props.elementId}
                className={props.className}
                block={props.block}
        ><i className={props.iconType} style={styles.faIconStyle}></i> {props.text}</Button>
    );
};

TopButtonAction.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string,
    iconType: PropTypes.string,
    btnColor: PropTypes.string,
    btnDisabled: PropTypes.bool,
    block: PropTypes.bool,
    elementId: PropTypes.string,
    btnSize: PropTypes.string,
    className: PropTypes.string,
    elementStyle: PropTypes.any
};

TopButtonAction.defaultProps = {
    text: 'Dodaj',
    iconType: 'fa fa-lg fa-save',
    btnColor: 'primary',
    btnSize: 'small',
    btnDisabled: false,
    block: false
};


export const TopButtonPointRemove = (props) => {
    return (
        <Button onClick={props.onClick}
                style={styles.buttonPointRemoveStyle}
                bsStyle='default'
                bsSize='small'
                title={props.titleContent}
                data-action={props.actionType}
                className="TopButtonPointRemoveClass"
                disabled={props.disabled}
        ><i className='fa fa-lg fa-remove' data-action={props.actionType}></i></Button>
    );
};

TopButtonPointRemove.propTypes = {
    onClick: PropTypes.func.isRequired,
    actionType: PropTypes.string,
    titleContent: PropTypes.string,
    disabled: PropTypes.bool,
};

TopButtonPointRemove.defaultProps = {
    actionType: 'zablokuj',
    titleContent: 'Usuń',
    disabled:false
};

export const TopButtonPointEdit = (props) => {
    return (
        <Button onClick={props.onClick}
                style={styles.buttonPointEditStyle}
                bsStyle='default'
                bsSize='small'
                title={props.titleContent}
                className="TopButtonPointEditClass"
                disabled={props.disabled}
        ><i className={props.iconType}></i></Button>
    );
};

TopButtonPointEdit.propTypes = {
    onClick: PropTypes.func.isRequired,
    titleContent: PropTypes.string,
    iconType: PropTypes.string,
    disabled: PropTypes.bool,
};

TopButtonPointEdit.defaultProps = {
    titleContent: 'Edytuj',
    iconType: 'fa fa-lg fa-pencil',
    disabled:false
};


export const TopButtonPointAction = (props) => {
    return (
        <Button onClick={props.onClick}
                style={styles.buttonPointActionStyle}
                bsStyle={props.buttonColor}
                bsSize='small'
                title={props.titleContent}
                data-action={props.dataAction}
                disabled={props.disabled}
                className={props.className}
        ><i className={props.buttonIcon} data-action={props.dataAction}></i></Button>
    );
};

TopButtonPointAction.propTypes = {
    onClick: PropTypes.func.isRequired,
    titleContent: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonIcon: PropTypes.string,
    dataAction: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

TopButtonPointAction.defaultProps = {
    titleContent: 'Edytuj',
    buttonColor: "default",
    buttonIcon: 'fa fa-lg fa-hand-pointer-o',
    dataAction: '',
    className: '',
    disabled:false
};


// WEBPACK FOOTER //
// ./src/componentsTopsa/buttons/TopButtons.js